import Axios, {AxiosInstance, AxiosPromise} from 'axios';
import ApiService from './apiService';
import LifeSpa from 'types/ls/lifespa';

export const LifeSpaServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: window.lt.api.apimUrl + 'lifespa/v2',
	headers: {
		'Ocp-Apim-Subscription-Key': window.lt.api.apimKey,
	},
});

export default class LifeSpaService extends ApiService implements LifeSpa.ILifeSpaService {
	constructor() {
        super('lifespa-service', LifeSpaServiceAxiosInstance);
    }

    public getSpaCategories(clubId: number): AxiosPromise<LifeSpa.ILifeSpaCategories> {
		return this.axiosInstance.get('locations/' + clubId + '/services');
	}

	public getAppointments(clubId: number, start: string, serviceId: string, weeks: number): AxiosPromise<LifeSpa.ILifeSpaWeekday[]> {
		return this.axiosInstance.get('locations/' + clubId + '/appointments/search?start=' + start + '&serviceId=' + serviceId + '&weeks=' + weeks);
	}

	public getClubInfo(clubId: number): AxiosPromise<LifeSpa.IClubInfo> {
		return this.axiosInstance.get('locations/' + clubId);
	}

	public getSpaBizUser(data: LifeSpa.ISpaBizLoginData): AxiosPromise<LifeSpa.ISpaBizUser> {
		return this.axiosInstance.post('customer/login', data);
	}

	public bookAppointment(data: LifeSpa.ISpaBizAppointmentInfo): AxiosPromise<LifeSpa.ISpaBizAppointmentResponse> {
		return this.axiosInstance.post('customer/appointment', data);
	}
}
